import animation from './ObsidianHeroMaterial.animation.json';
import { parallax } from '@immutabl3/alchemy/three';

export default function ObsidianHeroMaterial({ map, normalMap }) {
  return (
    <parallax.meshPhysicalMaterial
      beaker="chapter3"
      animation={ animation }

      map={ map }
      normalMap={ normalMap }
      roughnessMap={ null }
      roughness={ 0.66 }
      reflectivity={ 0.1 }
      specularIntensity={ 0.1 }
      ior={ 1.1 }
      color={ [0.5, 0.5, 0.5] }
      metalnessMap={ null }
      metalness={ 0 }
      specularColor={ [1, 1, 1] }
      emissive={ [6.5, 5.5, 4.5] }
    />
  );
}